import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

export interface Option {
  value: string;
  label: string;
}

@Component({
  selector: 'app-cliente-select',
  standalone: true,
  imports: [FormsModule, NgSelectModule],
  templateUrl: './cliente-select-component.html',
  styleUrl: './cliente-select-component.scss',
})
export class ClienteSelectComponent {
  /** Opciones que se muestran en el dropdown */
  @Input() options: Option[] = [];

  /** Opción actualmente seleccionada */
  @Input() selected?: Option;

  /** Placeholder para el dropdown */
  @Input() placeholder: string = '';

  /** Emite la opción seleccionada al padre */
  @Output() selectionChange = new EventEmitter<Option>();

  @Input() compact = false;

  /** Manejar el cambio del ng-select */
  onChange(opt: Option) {
    this.selectionChange.emit(opt);
  }
}
